import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { installErrorReporting } from "./report.js";
import { applyTheme } from "./portal/prefs.js";
import { startMe } from "./portal/data.js";
import "./styles.css";
import "./builder/builder.css";
import "./kit/kit.css";

installErrorReporting();
applyTheme();
// Before the router: it renders nothing until the first page's lazy chunk arrives.
startMe();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
